<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[{ name: 'Human Resource', to: { path: '/human-resource' } }]"
    ></Breadscrumbs>
    <div class="page-actions">
      <h2>Human Resource</h2>
      <v-spacer></v-spacer>
      <button class="btn">
        <v-icon class="mr-2">get_app</v-icon>
        <span>匯出</span>
      </button>
    </div>
    <!-- table -->
    <ResumeTable></ResumeTable>
  </div>
</template>

<script>
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import ResumeTable from '@/views/J__HR/c/ResumeTable.vue';

export default {
  components: {
    Breadscrumbs,
    ResumeTable,
  },
};
</script>

<style></style>
